import { cn } from "@/modules/lib/utils"
import ProgramInfiniteEmpty from "@images/empty/program_infinite_empty.svg"
import ProgramOnOffEmpty from "@images/empty/program_on_off_empty.svg"
import { word } from "@modules/core/utils/i18n"
import { useProgramSidebar } from "@modules/programs/hooks/useProgramSidebar"
import { ProgramType } from "@modules/programs/types/programTypes"
import { Text } from "@/components/ui/baseUi/text"

export function ProgramSelectView({ className, ...props }: React.ComponentProps<"div">) {
  const { navigateToProgramCreation } = useProgramSidebar()

  const onCreateProgramInfiniteClick = () => {
    navigateToProgramCreation(ProgramType.VIRTUAL)
  }

  const onCreateProgramOnOffClick = () => {
    navigateToProgramCreation(ProgramType.ONOFF)
  }

  return (
    <div className={cn("flex flex-col gap-8 px-5 pt-18 pb-6", className)} {...props}>
      <div className="flex flex-col gap-2 pb-5">
        <Text fontStyle="TL">{word("program.form.addProgram.title")}</Text>
        <Text fontStyle="BS" className="text-textDefault-body">
          {word("program.form.addProgram.description")}
        </Text>
      </div>
      <ProgramCard
        imageSrc={ProgramInfiniteEmpty}
        title={word("program.create.infinite.title")}
        description={word("program.create.infinite.description")}
        onButtonClick={onCreateProgramInfiniteClick}
      />
      <ProgramCard
        imageSrc={ProgramOnOffEmpty}
        title={word("program.create.on_off.title")}
        description={word("program.create.on_off.description")}
        onButtonClick={onCreateProgramOnOffClick}
      />
    </div>
  )
}

type ProgramCardProps = {
  imageSrc: string
  title: string
  description: string
  onButtonClick: () => void
  className?: string
} & React.ComponentProps<"div">
function ProgramCard({ imageSrc, title, description, onButtonClick, className }: ProgramCardProps) {
  return (
    <div
      className={cn(
        "group flex cursor-pointer flex-row items-center gap-4 rounded-4xl bg-surface-foreground px-6 py-4 ring-1 ring-transparent transition-colors duration-300 hover:bg-surface-background hover:ring-neutral-300",
        className,
      )}
      onClick={onButtonClick}
    >
      <img src={imageSrc} style={{ width: 120 }} alt="Card Image" />
      <div className="flex flex-col gap-2">
        <Text
          fontStyle="TM"
          className="relative w-fit after:absolute after:bottom-1 after:left-0 after:h-px after:w-0 after:bg-current after:transition-all after:duration-300 group-hover:after:w-full"
        >
          {title}
        </Text>
        <Text fontStyle="BS" className="text-textDefault-body">
          {description}
        </Text>
      </div>
    </div>
  )
}
